// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2G6CG","header":"styles_header__3lWjA","content":"styles_content__2xcOt"};